<template>
  <div class="g-layout g-h100">
    <headBar/>
    <mainBar class="g-main">
      <router-view/>
    </mainBar>
    <footBar/>
  </div>
</template>
<script>
import headBar from "@/components/headbar/index"
import mainBar from "@/components/mainbar/index"
import footBar from "@/components/footbar/index"
export default {
  name:"layuot",
  data () {
    return {

    }
  },
  components: {
    headBar,
    mainBar,
    footBar
  }
}
</script>
<style lang="less" scoped>
.g-main{
  min-height: calc( ~"100% - 204px");
}
</style>




// WEBPACK FOOTER //
// src/components/layout/index.vue